import React from 'react'

import ServiceChart from './ServiceChart'
import Legend from './Legend'
import { useStateWithLocalStorage } from './localStorage'

const ServiceList = ({ services, incidents, incidentServices, inTimezone, asOfDate, daysBack, rangeOffset, onRangeOffset, isLeanDisplay, dateOffsetBugfixEnabled }) => {
  const [expandedServices, setExpandedServices] = useStateWithLocalStorage('expandedServices')

  const updateExpandedServices = (serviceIdString, add) => {
    const expandedServicesArray = (expandedServices === '' ? [] : expandedServices.split(','))
    if (expandedServicesArray.includes(serviceIdString) & !add) {
      const index = expandedServicesArray.indexOf(serviceIdString)
      expandedServicesArray.splice(index, 1)
    }
    if (!expandedServicesArray.includes(serviceIdString) & add) {
      expandedServicesArray.push(serviceIdString)
    }
    setExpandedServices(expandedServicesArray.join())
  }

  if (services && services.length > 0) {
    return (
      <div>
        <Legend/>
        {services.map(service => {
          return (
            <ServiceChart
              key={service.id.toString()}
              service={service}
              incidents={incidents}
              incidentServices={incidentServices}
              inTimezone={inTimezone}
              asOfDate={asOfDate}
              daysBack={daysBack}
              rangeOffset={rangeOffset}
              onRangeOffset={onRangeOffset}
              expandedServices={expandedServices.split(',')}
              updateExpandedServices={updateExpandedServices}
              isLeanDisplay={isLeanDisplay}
              dateOffsetBugfixEnabled={dateOffsetBugfixEnabled}
            />
          )
        })}
        <Legend/>
      </div>
    )
  }
  return (
    <div style={{ marginTop: "100px" }}>
      <div>No services for subdomain</div>
    </div>
  )
}

export default ServiceList
